const container = document.querySelector('.sticky-scrolling-container__inner');
const sections = document.querySelectorAll('section');
const imageContainer = document.querySelector('.sticky-scrolling-container__image');
const scollingContainer = document.getElementById('scrolling-container');

let currentActiveSection = null; // Keep track of the currently active section

const player = document.querySelector(".sticky-scrolling-container__sticky-image");

window.addEventListener('scroll', function() {
  const options = {
    rootMargin: '-50% 0px -50% 0px',
    threshold: 0
  };

  if(scollingContainer) {
  
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const visibleSection = entry.target;
        if (entry.isIntersecting) {
          if (currentActiveSection !== visibleSection) {
            // Section has changed, perform your actions here
            const newImage = visibleSection.dataset.image;
            player.load(newImage);
  
            // Remove active class from the previous active section
            if (currentActiveSection) {
              currentActiveSection.classList.remove('sticky-scrolling-container__active');
            }
  
            // Update the currently active section
            currentActiveSection = visibleSection;
  
            // Add active class to the new active section
            visibleSection.classList.add('sticky-scrolling-container__active');
          }
        }
      });
    }, options);
  
    sections.forEach(section => {
      observer.observe(section);
    });
  }

});


// MOBILE PLAY ANIMATION
const lottieMobileElements = document.querySelectorAll(".lottie-mobile");

// Options for the Intersection Observer
const optionsMobile = {
  root: null, // Use the viewport as the root
  rootMargin: '0px', // No margin
  threshold: 0.5 // Trigger when 50% of the target is visible
};

// Callback function to handle intersection changes
const callbackForMobile = (entries, observer) => {
  entries.forEach(entry => {
    const lottieMobile = entry.target;
    if (entry.isIntersecting) {
      // The target element is in the viewport
      lottieMobile.play();
    } else {
      // The target element is not in the viewport
      lottieMobile.stop();
    }
  });
};

// Create an Intersection Observer with the callback and options
const observerForMobile = new IntersectionObserver(callbackForMobile, optionsMobile);

// Start observing each target element
lottieMobileElements.forEach(lottieMobile => {
  observerForMobile.observe(lottieMobile);
});
